module.exports = __webpack_public_path__ + "img/profile.2f4dd960.jpg";